import { useCallback } from 'react';
import { useSearchParams } from 'react-router';

import type { PeriodWindow } from '~/components/serviceHistory/periodWindow';
import {
  isPeriodWindow,
  periodWindowParam,
  ROLLING_WINDOW,
} from '~/components/serviceHistory/periodWindow';

export function usePeriodWindow(): [PeriodWindow, (next: PeriodWindow) => void] {
  const [searchParams, setSearchParams] = useSearchParams();
  const fromUrl = searchParams.get(periodWindowParam);
  const window = isPeriodWindow(fromUrl) ? fromUrl : ROLLING_WINDOW;

  const setWindow = useCallback(
    (next: PeriodWindow) => {
      setSearchParams(
        (prev) => {
          if (next === ROLLING_WINDOW) {
            prev.delete(periodWindowParam);
          } else {
            prev.set(periodWindowParam, next);
          }
          return prev;
        },
        { replace: true },
      );
    },
    [setSearchParams],
  );

  return [window, setWindow];
}
